import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const PARTNER360_PARTNER_FLAGS_NAMESPACE = `${PARTNER360_NAMESPACE}/partner-flags`

// Async thunk constants
export const REQUEST_P360_PARTNER_FLAGS = `${PARTNER360_PARTNER_FLAGS_NAMESPACE}/requestP360PartnerFlags`
